import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'NETCG & ASOCIADOS - Asesoría Integral en España';
  }, []);
  return <LandingPage data-id="element-0" />;
}